import { SimilarKanjiGroup } from "../../consts/similarKanjiGroups";

// "kanjiToMeaning": the kanji is shown, the choices are meanings.
// "meaningToKanji": the meaning and reading are shown, the choices are kanji.
export type QuizDirection = "kanjiToMeaning" | "meaningToKanji";

export interface SimilarKanjiQuestion {
    groupId: string;
    answer: string;
    direction: QuizDirection;
    // Every member of the group, shuffled. Always the whole group, never kanji
    // from elsewhere.
    options: string[];
}

export const QUIZ_ROUND_LENGTH = 10;

export function shuffle<T>(items: readonly T[], random: () => number = Math.random): T[] {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}

// One question per group, from up to `length` shuffled groups (every group once
// when there are fewer). The target member is random, and directions alternate
// from a random start so both kinds appear.
export function buildRound(
    groups: readonly SimilarKanjiGroup[],
    length: number = QUIZ_ROUND_LENGTH,
    random: () => number = Math.random,
): SimilarKanjiQuestion[] {
    const picked = shuffle(groups, random).slice(0, length);
    const firstDirection = random() < 0.5 ? 0 : 1;
    return picked.map((group, index) => {
        const symbols = group.members.map((member) => member.symbol);
        const answer = symbols[Math.floor(random() * symbols.length)];
        const direction: QuizDirection = (index + firstDirection) % 2 === 0 ? "kanjiToMeaning" : "meaningToKanji";
        return { groupId: group.id, answer, direction, options: shuffle(symbols, random) };
    });
}

// "—" marks a reading the kanji does not have.
export function readingOrNull(reading: string): string | null {
    return reading.trim() === "—" ? null : reading;
}
